import { NodeType } from '@shared/interfaces';

const CONSTANTS = {
  ENGAGE_BUCKET: 'ciep-engage',
  BACKGROUND_IMAGE_PATH: 'organization/backgroundImages/',
  AUTHENTICATIONDETAILSKEY: 'authenticationDetailsKey',
  FTPCONFIGURATIONKEY: 'ftpConfigurationKey',
  CONFIGURATIONDETAILSKEY: 'configurationDetailsKey',
  CURRENT_APPLICATION_NAME: 'om',
  DEFAULT_LOCALE: 'en-GB',
  PASSWORD_VALIDATION_REGEX: '^(?=.{6,}).*$',
  IDLE_TIMEOUT: 2400, // Sets an idle timeout of 2400 seconds = 40 min.
  TIMEOUT: 300, // Sets a timeout period of 300 seconds = 5 min.
  // After 5 minutes of inactivity, the user will be considered timed out and logout.
  KEEP_ALIVE: 3300, // Sets the ping interval to 3300 seconds = 55 min to reset Access Token
  TM: 'TM',
  SAGA: 'SAGA',
  OM: 'OM',
  RJ: 'RJ',
  EBASKET: 'eBasket',
  T2S: 'T2S',
  SOTK: 'SOTK',
  ENGAGE: 'Engage',
  DOTI: 'DOTI',
  WISP: 'WISP',
  INTERACT: 'Interact',
  CUSTOMER_HUB: 'CustomerHub',
  GLIDE: 'Glide',
  T2B: 'T2B',
  CRESTENGAGEMENT: 'crestEngagement',
  ROSS: 'Ross',
  COMPANY: 'COMPANY',
  ORGANIZATION: 'ORGANIZATION',
  CREST: 'Crest',
  EBASKET_ID: '5',
  YES: 'YES',
  NO: 'NO',
  DEFAULT_ROUTING: 'users',
  getCurrentLevel: (rootNode: string): number => {
    switch (rootNode) {
      case NodeType.GLOBAL:
        return 60;
      case NodeType.ORGANIZATION:
        return 50;
      case NodeType.COMPANY:
        return 40;
      case NodeType.TRADING_REGION:
        return 30;
      case NodeType.STORE_GROUP || NodeType.SUB_STORE_GROUP:
        return 20;
      case NodeType.STORE:
        return 10;
    }
  },
  paymentOptions: [
    {
      id: 1,
      name: 'Cash',
      type: 'TMC_CASH',
      authCode: 'cashAuthCode',
      basketInfo: 'cashBasketInfo',
      transactionLimit: 'cashTransactionLimit',
      minPaymentAmount: 'cashMinPaymentAmount',
      maxPaymentAmount: 'cashMaxPaymentAmount',
      displayName: 'cashdisplayName',
      webhookCallbackUrl: 'cashWebhookCallbackUrl',
      externalType: 'cashexternal',
      externalSubType: 'cashexternalsub',
      tenderItemKey: 'cashsimpleaccounttender',
      fulfilmentTypes: {
        clickNCollect: true,
        inStore: true,
        shipToStore: true,
        webOrder: true
      }
    },
    {
      id: 2,
      name: 'Card',
      type: 'Unintegrated',
      authCode: 'cardAuthCode',
      basketInfo: 'cardBasketInfo',
      transactionLimit: 'cardTransactionLimit',
      minPaymentAmount: 'cardMinPaymentAmount',
      maxPaymentAmount: 'cardMaxPaymentAmount',
      displayName: 'carddisplayName',
      webhookCallbackUrl: 'cardWebhookCallbackUrl',
      externalType: 'cardexternal',
      externalSubType: 'cardexternalsub',
      tenderItemKey: 'cardsimpleaccounttender',
      fulfilmentTypes: {
        clickNCollect: true,
        inStore: true,
        shipToStore: true,
        webOrder: true
      }
    },
    {
      id: 3,
      name: 'Contactless',
      type: 'Unintegrated',
      authCode: 'contactlessAuthCode',
      basketInfo: 'contactlessBasketInfo',
      transactionLimit: 'contactTransactionLimit',
      minPaymentAmount: 'contactMinPaymentAmount',
      maxPaymentAmount: 'contactMaxPaymentAmount',
      displayName: 'contactlessdisplayName',
      webhookCallbackUrl: 'contactlessWebhookCallbackUrl',
      externalType: 'contactlessexternal',
      externalSubType: 'contactlessexternalsub',
      tenderItemKey: 'contactlesssimpleaccounttender',
      fulfilmentTypes: {
        clickNCollect: true,
        inStore: true,
        shipToStore: true,
        webOrder: true
      }
    },
    {
      id: 4,
      name: 'Amex',
      type: 'Unintegrated',
      authCode: 'AmexAuthCode',
      basketInfo: 'AmexBasketInfo',
      transactionLimit: 'AmexTransactionLimit',
      minPaymentAmount: 'AmexMinPaymentAmount',
      maxPaymentAmount: 'AmexMaxPaymentAmount',
      displayName: 'AmexdisplayName',
      webhookCallbackUrl: 'AmexWebhookCallbackUrl',
      externalType: 'Amexexternal',
      externalSubType: 'Amexexternalsub',
      tenderItemKey: 'Amexsimpleaccounttender',
      fulfilmentTypes: {
        clickNCollect: true,
        inStore: true,
        shipToStore: true,
        webOrder: true
      }
    },
    {
      id: 5,
      name: 'WeChat',
      type: 'Unintegrated',
      authCode: 'WeChatAuthCode',
      basketInfo: 'WeChatBasketInfo',
      transactionLimit: 'WeChatTransactionLimit',
      minPaymentAmount: 'WeChatMinPaymentAmount',
      maxPaymentAmount: 'WeChatMaxPaymentAmount',
      displayName: 'WeChatdisplayName',
      webhookCallbackUrl: 'WeChatWebhookCallbackUrl',
      externalType: 'WeChatexternal',
      externalSubType: 'WeChatexternalsub',
      tenderItemKey: 'WeChatsimpleaccounttender',
      fulfilmentTypes: {
        clickNCollect: true,
        inStore: true,
        shipToStore: true,
        webOrder: true
      }
    },
    {
      id: 6,
      name: 'AliPay',
      type: 'Unintegrated',
      authCode: 'AliPayAuthCode',
      basketInfo: 'AliPayBasketInfo',
      transactionLimit: 'AliPayTransactionLimit',
      minPaymentAmount: 'AliPayMinPaymentAmount',
      maxPaymentAmount: 'AliPayMaxPaymentAmount',
      displayName: 'AliPaydisplayName',
      webhookCallbackUrl: 'AliPayWebhookCallbackUrl',
      externalType: 'AliPayexternal',
      externalSubType: 'AliPayexternalsub',
      tenderItemKey: 'Alisimpleaccounttender',
      fulfilmentTypes: {
        clickNCollect: true,
        inStore: true,
        shipToStore: true,
        webOrder: true
      }
    },
    {
      id: 7,
      name: 'Gift Card',
      type: 'TMC_GIFTCARD',
      authCode: 'GiftAuthCode',
      basketInfo: 'GiftBasketInfo',
      transactionLimit: 'GiftTransactionLimit',
      minPaymentAmount: 'GiftMinPaymentAmount',
      maxPaymentAmount: 'GiftMaxPaymentAmount',
      displayName: 'GiftdisplayName',
      webhookCallbackUrl: 'GiftWebhookCallbackUrl',
      externalType: 'Giftexternal',
      externalSubType: 'Giftexternalsub',
      tenderItemKey: 'Giftsimpleaccounttender',
      fulfilmentTypes: {
        clickNCollect: true,
        inStore: true,
        shipToStore: true,
        webOrder: true
      }
    },
    {
      id: 8,
      name: 'Disney Points',
      type: 'Unintegrated',
      authCode: 'DisneyAuthCode',
      basketInfo: 'DisneyBasketInfo',
      transactionLimit: 'DisneyTransactionLimit',
      minPaymentAmount: 'DisneyMinPaymentAmount',
      maxPaymentAmount: 'DisneyMaxPaymentAmount',
      displayName: 'DisneydisplayName',
      webhookCallbackUrl: 'DisneyWebhookCallbackUrl',
      externalType: 'Disneyexternal',
      externalSubType: 'Disneyexternalsub',
      tenderItemKey: 'Disneysimpleaccounttender',
      fulfilmentTypes: {
        clickNCollect: true,
        inStore: true,
        shipToStore: true,
        webOrder: true
      }
    },
    {
      id: 9,
      name: 'Venmo',
      type: 'Unintegrated',
      authCode: 'VenmoAuthCode',
      basketInfo: 'VenmoBasketInfo',
      transactionLimit: 'VenomTransactionLimit',
      minPaymentAmount: 'VenmoMinPaymentAmount',
      maxPaymentAmount: 'VenmoMaxPaymentAmount',
      displayName: 'VenmodisplayName',
      webhookCallbackUrl: 'VenmoWebhookCallbackUrl',
      externalType: 'Venmoexternal',
      externalSubType: 'Venmoexternalsub',
      tenderItemKey: 'Venmosimpleaccounttender',
      fulfilmentTypes: {
        clickNCollect: true,
        inStore: true,
        shipToStore: true,
        webOrder: true
      }
    },
    {
      id: 10,
      name: 'Afterpay',
      type: 'Unintegrated',
      authCode: 'AfterpayAuthCode',
      basketInfo: 'AfterpayBasketInfo',
      transactionLimit: 'AfterpayTransactionLimit',
      minPaymentAmount: 'AfterpayMinPaymentAmount',
      maxPaymentAmount: 'AfterpayMaxPaymentAmount',
      displayName: 'AfterpaydisplayName',
      webhookCallbackUrl: 'AfterpayWebhookCallbackUrl',
      externalType: 'Afterpayexternal',
      externalSubType: 'Afterpayexternalsub',
      tenderItemKey: 'Afterpayexternalsubtender',
      fulfilmentTypes: {
        clickNCollect: true,
        inStore: true,
        shipToStore: true,
        webOrder: true
      }
    },
    {
      id: 11,
      name: 'Unionpay',
      type: 'Unintegrated',
      authCode: 'UnionpayAuthCode',
      basketInfo: 'UnionpayBasketInfo',
      transactionLimit: 'UnionPayTransactionLimit',
      minPaymentAmount: 'UnionPayMinPaymentAmount',
      maxPaymentAmount: 'UnionPayMaxPaymentAmount',
      displayName: 'UnionpaydisplayName',
      webhookCallbackUrl: 'UnionpayWebhookCallbackUrl',
      externalType: 'Unionpayexternal',
      externalSubType: 'Unionpayexternalsub',
      tenderItemKey: 'Unionsimpleaccounttender',
      fulfilmentTypes: {
        clickNCollect: true,
        inStore: true,
        shipToStore: true,
        webOrder: true
      }
    },
    {
      id: 12,
      name: 'Paypal',
      type: 'Unintegrated',
      authCode: 'PaypalAuthCode',
      basketInfo: 'PaypalBasketInfo',
      transactionLimit: 'PaypalTransactionLimit',
      minPaymentAmount: 'PaypalMinPaymentAmount',
      maxPaymentAmount: 'PaypalMaxPaymentAmount',
      displayName: 'PaypaldisplayName',
      webhookCallbackUrl: 'PaypalWebhookCallbackUrl',
      externalType: 'Paypalexternal',
      externalSubType: 'Paypalexternalsub',
      tenderItemKey: 'Paypalsimpleaccounttender',
      fulfilmentTypes: {
        clickNCollect: true,
        inStore: true,
        shipToStore: true,
        webOrder: true
      }
    },
    {
      id: 13,
      name: 'Klarna',
      type: 'Unintegrated',
      authCode: 'KlarnaAuthCode',
      basketInfo: 'KlarnaBasketInfo',
      transactionLimit: 'KlarnaTransactionLimit',
      minPaymentAmount: 'KlarnaMinPaymentAmount',
      maxPaymentAmount: 'KlarnaMaxPaymentAmount',
      displayName: 'KlarndisplayName',
      webhookCallbackUrl: 'KlarnWebhookCallbackUrl',
      externalType: 'Klarnaexternal',
      externalSubType: 'Klarnaexternalsub',
      tenderItemKey: 'Klarnasimpleaccounttender',
      fulfilmentTypes: {
        clickNCollect: true,
        inStore: true,
        shipToStore: true,
        webOrder: true
      }
    },
    {
      id: 14,
      name: 'Remote Pay',
      type: 'Unintegrated',
      authCode: 'RemoteAuthCode',
      basketInfo: 'RemoteBasketInfo',
      transactionLimit: 'RemoteTransactionLimit',
      minPaymentAmount: 'RemoteMinPaymentAmount',
      maxPaymentAmount: 'RemoteMaxPaymentAmount',
      displayName: 'RemotedisplayName',
      webhookCallbackUrl: 'RemoteWebhookCallbackUrl',
      externalType: 'Remoteexternal',
      externalSubType: 'Remotexternalsub',
      tenderItemKey: 'Remotesimpleaccounttender',
      fulfilmentTypes: {
        clickNCollect: true,
        inStore: true,
        shipToStore: true,
        webOrder: true
      }
    },
    {
      id: 15,
      name: 'Card',
      type: 'SEPAY',
      authCode: 'SEPAYAuthCode',
      basketInfo: 'SEPAYBasketInfo',
      transactionLimit: 'SEPAYTransactionLimit',
      minPaymentAmount: 'SEPAYMinPaymentAmount',
      maxPaymentAmount: 'SEPAYMaxPaymentAmount',
      displayName: 'SEPAYdisplayName',
      webhookCallbackUrl: 'SEPAYWebhookCallbackUrl',
      externalType: 'SEPAYexternal',
      externalSubType: 'SEPAYexternalsub',
      tenderItemKey: 'SEPAYsimpleaccounttender',
      fulfilmentTypes: {
        clickNCollect: true,
        inStore: true,
        shipToStore: true,
        webOrder: true
      }
    },
    {
      id: 16,
      name: 'PDQ',
      type: 'Unintegrated',
      authCode: 'PDQAuthCode',
      basketInfo: 'PDQBasketInfo',
      transactionLimit: 'PDQTransactionLimit',
      minPaymentAmount: 'PDQMinPaymentAmount',
      maxPaymentAmount: 'PDQMaxPaymentAmount',
      displayName: 'PDQdisplayName',
      webhookCallbackUrl: 'PDQWebhookCallbackUrl',
      externalType: 'PDQexternal',
      externalSubType: 'PDQexternalsub',
      tenderItemKey: 'PDQsimpleaccounttender',
      fulfilmentTypes: {
        clickNCollect: true,
        inStore: true,
        shipToStore: true,
        webOrder: true
      }
    },
    {
      id: 17,
      name: 'Pay By Link',
      type: 'Unintegrated',
      authCode: 'paybylinkeAuthCode',
      basketInfo: 'paybylinkBasketInfo',
      transactionLimit: 'paybylinkTransactionLimit',
      minPaymentAmount: 'paybylinkMinPaymentAmount',
      maxPaymentAmount: 'paybylinkMaxPaymentAmount',
      displayName: 'paybylinkdisplayName',
      webhookCallbackUrl: 'paybylinkWebhookCallbackUrl',
      externalType: 'paybylinkexternal',
      externalSubType: 'paybylinkexternalsub',
      tenderItemKey: 'paybylinkesimpleaccounttender',
      fulfilmentTypes: {
        clickNCollect: true,
        inStore: true,
        shipToStore: true,
        webOrder: true
      }
    },
    {
      id: 18,
      name: 'KNET',
      type: 'KNET',
      authCode: 'KNETAuthCode',
      basketInfo: 'KNETBasketInfo',
      transactionLimit: 'KNETTransactionLimit',
      minPaymentAmount: 'KNETMinPaymentAmount',
      maxPaymentAmount: 'KNETMaxPaymentAmount',
      displayName: 'KNETdisplayName',
      webhookCallbackUrl: 'KNETWebhookCallbackUrl',
      externalType: 'KNETxternal',
      externalSubType: 'KNETxternalsub',
      tenderItemKey: 'KNETimpleaccounttender',
      fulfilmentTypes: {
        clickNCollect: true,
        inStore: true,
        shipToStore: true,
        webOrder: true
      }
    },
    {
      id: 19,
      name: 'Cheque',
      type: 'TMC_CHEQUE',
      authCode: 'ChequeAuthCode',
      basketInfo: 'ChequeBasketInfo',
      transactionLimit: 'ChequeTransactionLimit',
      minPaymentAmount: 'ChequeMinPaymentAmount',
      maxPaymentAmount: 'ChequeMaxPaymentAmount',
      displayName: 'ChequedisplayName',
      webhookCallbackUrl: 'ChequeWebhookCallbackUrl',
      externalType: 'Chequexternal',
      externalSubType: 'Chequexternalsub',
      tenderItemKey: 'Chequeimpleaccounttender',
      fulfilmentTypes: {
        clickNCollect: true,
        inStore: true,
        shipToStore: true,
        webOrder: true
      }
    },
    {
      id: 20,
      name: 'Gift Voucher',
      type: 'TMC_GIFTVOUCHER',
      authCode: 'GiftvAuthCode',
      basketInfo: 'GiftvBasketInfo',
      transactionLimit: 'GiftvTransactionLimit',
      minPaymentAmount: 'GiftvMinPaymentAmount',
      maxPaymentAmount: 'GiftvMaxPaymentAmount',
      displayName: 'GiftvdisplayName',
      webhookCallbackUrl: 'GiftvWebhookCallbackUrl',
      externalType: 'GiftvTxternal',
      externalSubType: 'Giftvxternalsub',
      tenderItemKey: 'Giftvimpleaccounttender',
      fulfilmentTypes: {
        clickNCollect: true,
        inStore: true,
        shipToStore: true,
        webOrder: true
      }
    },
    {
      id: 21,
      name: 'Klarna',
      type: 'SEPAY',
      authCode: 'KlarnaSEPAYAuthCode',
      basketInfo: 'KlarnaSEPAYBasketInfo',
      transactionLimit: 'KlarnaSEPAYTransactionLimit',
      minPaymentAmount: 'KlarnaSEPAYMinPaymentAmount',
      maxPaymentAmount: 'KlarnaSEPAYMaxPaymentAmount',
      displayName: 'KlarnaSEPAYDisplayName',
      webhookCallbackUrl: 'KlarnaSEPAYWebhookCallbackUrl',
      externalType: 'KlarnaSEPAYExternal',
      externalSubType: 'KlarnaSEPAYExternalsub',
      tenderItemKey: 'KlarnaSEPAYImpleaccounttender',
      fulfilmentTypes: {
        clickNCollect: true,
        inStore: true,
        shipToStore: true,
        webOrder: true
      }
    },
    {
      id: 22,
      name: 'Adyen',
      type: 'SEPAY',
      authCode: 'AdyenAuthCode',
      basketInfo: 'AdyenBasketInfo',
      transactionLimit: 'AdyenTransactionLimit',
      minPaymentAmount: 'AdyenMinPaymentAmount',
      maxPaymentAmount: 'AdyenMaxPaymentAmount',
      displayName: 'AdyenDisplayName',
      webhookCallbackUrl: 'AdyenWebhookCallbackUrl',
      externalType: 'AdyenExternal',
      externalSubType: 'AdyenExternalsub',
      tenderItemKey: 'AdyenImpleaccounttender',
      fulfilmentTypes: {
        clickNCollect: true,
        inStore: true,
        shipToStore: true,
        webOrder: true
      }
    },
    {
      id: 23,
      name: 'Worldpay',
      type: 'SEPAY',
      authCode: 'WorldpayAuthCode',
      basketInfo: 'WorldpayBasketInfo',
      transactionLimit: 'WorldpayTransactionLimit',
      minPaymentAmount: 'WorldpayMinPaymentAmount',
      maxPaymentAmount: 'WorldpayMaxPaymentAmount',
      displayName: 'WorldpayDisplayName',
      webhookCallbackUrl: 'WorldpayWebhookCallbackUrl',
      externalType: 'WorldpayExternal',
      externalSubType: 'WorldpayExternalsub',
      tenderItemKey: 'WorldpayImpleaccounttender',
      fulfilmentTypes: {
        clickNCollect: true,
        inStore: true,
        shipToStore: true,
        webOrder: true
      }
    },
    {
      id: 24,
      name: 'Creditcall',
      type: 'SEPAY',
      authCode: 'CreditcallAuthCode',
      basketInfo: 'CreditcallBasketInfo',
      transactionLimit: 'CreditcallTransactionLimit',
      minPaymentAmount: 'CreditcallMinPaymentAmount',
      maxPaymentAmount: 'CreditcallMaxPaymentAmount',
      displayName: 'CreditcallDisplayName',
      webhookCallbackUrl: 'CreditcallWebhookCallbackUrl',
      externalType: 'CreditcallExternal',
      externalSubType: 'CreditcallExternalsub',
      tenderItemKey: 'CreditcallImpleaccounttender',
      fulfilmentTypes: {
        clickNCollect: true,
        inStore: true,
        shipToStore: true,
        webOrder: true
      }
    },
    {
      id: 25,
      name: 'Verifone',
      type: 'SEPAY',
      authCode: 'VerifoneAuthCode',
      basketInfo: 'VerifoneBasketInfo',
      transactionLimit: 'VerifoneTransactionLimit',
      minPaymentAmount: 'VerifoneMinPaymentAmount',
      maxPaymentAmount: 'VerifoneMaxPaymentAmount',
      displayName: 'VerifoneDisplayName',
      webhookCallbackUrl: 'VerifoneWebhookCallbackUrl',
      externalType: 'VerifoneExternal',
      externalSubType: 'VerifoneExternalsub',
      tenderItemKey: 'VerifoneImpleaccounttender',
      fulfilmentTypes: {
        clickNCollect: true,
        inStore: true,
        shipToStore: true,
        webOrder: true
      }
    }
  ],
  subPaymentOption: [
    {
      id: 1,
      name: 'Debit Card',
      type: 'Debit_Card'
    },
    {
      id: 2,
      name: 'Mastercard Credit',
      type: 'Mastercard_Credit'
    },
    {
      id: 3,
      name: 'Visa Credit',
      type: 'Visa_Credit'
    },
    {
      id: 4,
      name: 'Diner',
      type: 'Diner'
    },
    {
      id: 5,
      name: 'American Express',
      type: 'American_Express'
    },
    {
      id: 6,
      name: 'Apple Pay',
      type: 'Apple_Pay'
    },
    {
      id: 7,
      name: 'Android Pay',
      type: 'Android_Pay'
    }
  ],
  CNDOMAIN: '.cn',
  ROW: 'Rest of World',
  CN: 'China',
  saleFlowList: [
    {
      name: 'Default',
      value: 'default'
    },
    {
      name: 'Custom Ticketing',
      value: 'customTicketing'
    }
  ],
  promotionApplicationOptions: [
    {
      name: 'Apply best promotion',
      value: 'APPLY_BEST_PROMOTION'
    },
    {
      name: 'Apply staff discount in addition to other promotion',
      value: 'APPLY_STAFF_DISCOUNT_In_ADDITION_TO_OTHER_PROMOTION'
    }
  ],
  customTicketing: 'customTicketing',
  fiscalCountries: [
    {
      id: 1,
      name: 'France',
      value: 'France'
    },
    {
      id: 2,
      name: 'Germany',
      value: 'Germany'
    },
    {
      id: 3,
      name: 'Poland',
      value: 'Poland'
    },
    {
      id: 4,
      name: 'Spain',
      value: 'Spain'
    },
    {
      id: 5,
      name: 'Sweden',
      value: 'Sweden'
    },
    {
      id: 6,
      name: 'Austria',
      value: 'Austria'
    }
  ],
  REASONID_ALREADY_EXISTS_MSG: 'Reason ID already exists',
  IP_ALREADY_EXISTS_MSG: 'Duplicate: Device already exists',
  // The product recommendation list endpoint is paginated; the dropdown shows every
  // config in one go.
  PRODUCT_RECOMMENDATION_PAGE_LIMIT: 500
};
export enum COUNTRIES {
  POLAND = 'Poland',
  FRANCE = 'France',
  GERMANY = 'Germany',
  SPAIN = 'Spain'
}
export enum globalPortalAccessRights {
  OM_DASHBOARD = 'OM_DASHBOARD',
  VIEW_PROFILE = 'VIEW_PROFILE',
  LIST_USERS = 'LIST_USERS',
  CREATE_USER = 'CREATE_USER',
  VIEW_USER = 'VIEW_USER',
  ENABLED_USER = 'ENABLED_USER',
  EDIT_USER = 'EDIT_USER',
  DELETE_USER = 'DELETE_USER',
  LIST_ROLES = 'LIST_ROLES',
  CREATE_ROLE = 'CREATE_ROLE',
  DELETE_ROLE = 'DELETE_ROLE',
  EDIT_ROLE = 'EDIT_ROLE',
  VIEW_ROLE = 'VIEW_ROLE',
  ENABLED_ROLE = 'ENABLED_ROLE',
  CREATE_ORGANISATION = 'CREATE_ORGANISATION',
  VIEW_ORGANISATION = 'VIEW_ORGANISATION',
  MODULE_APP_ICON = 'MODULE_APP_ICON',
  ALLOW_TO_VIEW_MODULE_ICON = 'ALLOW_TO_VIEW_MODULE_ICON',
  UPDATE_ORGANISATION = 'UPDATE_ORGANISATION'
}

export enum TEMPLATE {
  USER_IMPORT_CSV_TEMPLATE_NAME = 'USER_IMPORT_CSV_TEMPLATE',
  PRE_FIX = 'Users',
  EXTENSION = 'csv',
  CONTENT_ENCODING = 'base64',
  CONTENT_TYPE = 'text/csv',
  UPLOAD_LOCATION = 'pmc'
}
export enum VIEW {
  MOBILE = 'mobile',
  TABLET = 'tablet'
}

export const MODULE_SCREENS = {
  EBASKET: [
    {
      name: 'Transactions',
      value: 'Transactions',
      children: [
        { name: 'History', value: 'transaction', children: [] },
        { name: 'Refund Process', value: 'transaction/refund', children: [] },
        { name: 'Product refund', value: 'transaction/productRefund', children: [] }
      ]
    },
    {
      name: 'Product management',
      value: 'Product management',
      children: [
        { name: 'Product list', value: 'product', children: [] },
        { name: 'Product Assignment', value: 'product/assignment', children: [] }
      ]
    },
    {
      name: 'Promotion manager',
      value: 'Promotion manager',
      children: [
        { name: 'Promotion list', value: 'promotion', children: [] },
        { name: 'Create promotion', value: 'promotion/create', children: [] }
      ]
    },
    {
      name: 'Reason code management',
      value: 'Reason code management',
      children: [
        { name: 'Reason list', value: 'reason/list', children: [] },
        { name: 'Create Reason Codes', value: 'reason/create', children: [] }
      ]
    },
    {
      name: 'Player management',
      value: 'Player management',
      children: [{ name: 'Player list', value: 'player', children: [] }]
    }
  ],
  EBASKET_DEFAULT: { name: 'History', value: 'transaction', children: [] },
  D2S: [
    {
      name: 'Order Management',
      value: 'Order Management',
      children: [{ name: 'Order List', value: 'orders', children: [] }]
    },
    {
      name: 'Customer Management',
      value: 'Customer Management',
      children: [
        { name: 'Customer List', value: 'customer', children: [] },
        { name: 'Add Customer', value: 'customer/create', children: [] }
      ]
    },
    {
      name: 'Product Management',
      value: 'Product Management',
      children: [
        { name: 'Product List', value: 'product', children: [] },
        { name: 'Create Product', value: 'product/create', children: [] },
        { name: 'Bulk Upload', value: 'product/bulk', children: [] }
      ]
    },
    {
      name: 'Campaign Management',
      value: 'Campaign Management',
      children: [
        { name: 'Campaign List', value: 'campaign', children: [] },
        { name: 'Create Campaign', value: 'campaign/create', children: [] }
      ]
    }
  ],
  D2S_DEFAULT: { name: 'Campaign List', value: 'campaign', children: [] },
  DOTI: [
    {
      name: 'Integration Management',
      value: 'Integration Management',
      children: [{ name: 'Integration List', value: 'integrations', children: [] }]
    }
  ],
  DOTI_DEFAULT: { name: 'Integration List', value: 'integrations', children: [] },
  TM: [
    {
      name: 'Drawer Management',
      value: 'Drawer Management',
      children: [
        { name: 'List', value: 'drawer-management', children: [] },
        { name: 'Create', value: 'drawer-management/create', children: [] },
        { name: 'Group List', value: 'drawer-management/group-list', children: [] },
        { name: 'Group Create', value: 'drawer-management/group-create', children: [] }
      ]
    },
    {
      name: 'Tenders',
      value: 'tenders',
      children: []
    },
    {
      name: 'Currencies and Exchange Rates',
      value: 'currencies-and-exchange-rates',
      children: []
    },
    {
      name: 'Cash Management',
      value: 'Cash Management',
      children: [
        {
          name: 'Cash Drawer Float',
          value: 'Cash Drawer Float',
          children: [
            {
              name: 'Float History',
              value: 'cash-management/cash-drawer-float/history',
              children: []
            }
          ]
        },
        {
          name: 'Cash Drawer Pickup',
          value: 'Cash Drawer Pickup',
          children: [
            {
              name: 'Pickup History',
              value: 'cash-management/cash-drawer-pickup/history',
              children: []
            }
          ]
        },
        {
          name: 'Cash Drawer Cashup',
          value: 'Cash Drawer Cashup',
          children: [
            {
              name: 'Cashup History',
              value: 'cash-management/cash-drawer-cashup/history',
              children: []
            }
          ]
        },
        {
          name: 'Cash Drawer Spot Check',
          value: 'Cash Drawer Spot Check',
          children: [
            {
              name: 'Spot Check History',
              value: 'cash-management/cash-drawer-spot/history',
              children: []
            }
          ]
        }
      ]
    },
    {
      name: 'Safe Management',
      value: 'Safe Management',
      children: [
        {
          name: 'Safe Spot Check',
          value: 'Safe Spot Check',
          children: [
            {
              name: 'Safe Spot Check History',
              value: 'safe-management/spot-check/history',
              children: []
            },
            {
              name: 'New Safe Spot Check',
              value: 'safe-management/spot-check/create',
              children: []
            }
          ]
        },
        {
          name: 'Safe Adjustment',
          value: 'Safe Adjustment',
          children: [
            {
              name: 'Safe Adjustment History',
              value: 'safe-management/adjustment/history',
              children: []
            },
            {
              name: 'New Safe Adjustment',
              value: 'safe-management/adjustment/create',
              children: []
            }
          ]
        },
        {
          name: 'Safe Cashup',
          value: 'Safe Cashup',
          children: [
            {
              name: 'Safe Cashup History',
              value: 'safe-management/cash-up/history',
              children: []
            },
            {
              name: 'New Safe Cashup',
              value: 'safe-management/cash-up/create',
              children: []
            }
          ]
        }
      ]
    },
    {
      name: 'Banking Management',
      value: 'Banking Management',
      children: [
        {
          name: 'Banking Management History',
          value: 'banking-management/history',
          children: []
        },
        {
          name: 'New Banking',
          value: 'banking-management/create',
          children: []
        },
        {
          name: 'Pending Collection',
          value: 'banking-management/pending',
          children: []
        }
      ]
    }
  ],
  TM_DEFAULT: {
    name: 'Safe Cashup History',
    value: 'safe-management/cash-up/history',
    children: []
  },

  OM: [
    {
      name: 'Administrators',
      value: 'Administrators',
      children: [
        { name: 'User List', value: 'users', children: [] },
        { name: 'Add User', value: 'users/create', children: [] },
        { name: 'Bulk User Import', value: 'users/import', children: [] }
      ]
    },
    {
      name: 'Role',
      value: 'Role',
      children: [
        { name: 'Role List', value: 'role', children: [] },
        { name: 'Create Role', value: 'role/create', children: [] }
      ]
    },
    {
      name: 'Structure',
      value: 'Structure',
      children: [
        { name: 'Hierarchy', value: 'structure/hierarchy', children: [] },
        { name: 'Add Node', value: 'structure/create', children: [] }
      ]
    }
  ],
  OM_DEFAULT: { name: 'User List', value: 'users', children: [] }
};

export const TRANSACTION_METHOD_LABELS = {
  inStore: 'In Store',
  webOrder: 'Web Order',
  clickNCollect: 'Click and Collect',
  shipToStore: 'Ship to Store'
};

export const ORDER_MANAGEMENT_LOCAL_STORAGE_KEY = {
  PRODUCT_DISPLAY_DETAIL_OPTIONS: 'productDetailConfigOption'
};

export const DEFAULT_TRANSACTION_NAMES = ['inStore', 'webOrder', 'clickNCollect', 'shipToStore'];

export const IP_ADDRESS_PATTERN = /^(25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)$/;

export default CONSTANTS;
